import { useEffect, useState } from "react";
import { listSessions } from "@/api/sessions";

export function useRecentLocations(sessionType?: "gym" | "outdoor"): string[] {
  const [locations, setLocations] = useState<string[]>([]);

  useEffect(() => {
    listSessions().then((sessions) => {
      const seen = new Set<string>();
      const unique: string[] = [];
      for (const s of sessions) {
        // Filter by type if specified; include untyped sessions as fallback
        if (sessionType && s.session_type && s.session_type !== sessionType) continue;
        if (s.gym_name && !seen.has(s.gym_name)) {
          seen.add(s.gym_name);
          unique.push(s.gym_name);
          if (unique.length === 8) break;
        }
      }
      setLocations(unique);
    });
  }, [sessionType]);

  return locations;
}
